<template>
  <section class="account-form">
    <el-form
      ref="form"
      :model="formData"
      :rules="formRule">
      <div
        v-if="!edit"
        class="form-block">
        <span>Account Type</span>
        <el-form-item
        >
          <v-radio-group
            v-model="formData.identity"
            :button="true"
            :list="userTypeOptions"
            @change="handlerChange" />
        </el-form-item>
      </div>
      <div v-if="formData.identity == 1">
        <div class="form-block">
          <span>Mobile Number</span>
          <el-form-item
            ref="phone"
            prop="phone"
            :rules="rules.mobile_no">
            <v-input
              v-model="formData.phone"
              maxlength="8"
              keyNumber
            />
          </el-form-item>
        </div>
        <div class="form-block">
          <span>Last Name</span>
          <el-form-item
            ref="isrd_lst_nm"
            prop="isrd_lst_nm">
            <v-input
              v-model="formData.isrd_lst_nm"
              uppercase />
          </el-form-item>
        </div>
        <div class="form-block">
          <span>First Name</span>
          <el-form-item
            ref="isrd_fst_nm"
            prop="isrd_fst_nm">
            <v-input
              v-model="formData.isrd_fst_nm"
              uppercase />
          </el-form-item>
        </div>
        <div class="form-block">
          <span>Email</span>
          <el-form-item
            ref="email"
            prop="email"
            :rules="rules.valid_email">
            <v-input v-model="formData.email" />
          </el-form-item>

        </div>
        <div class="form-block">
          <span>Title</span>
          <el-form-item
            ref="isrd_title"
            prop="isrd_title">
            <v-select
              v-model="formData.isrd_title"
              :list="titleOptions" />
          </el-form-item>
        </div>
        <div class="form-block">
          <span>Date of Birth</span>
          <el-form-item
            ref="isrd_dob"
            prop="isrd_dob">
            <v-birth-day v-model="formData.isrd_dob"></v-birth-day>
          </el-form-item>
        </div>
        <!-- <div class="form-block">
          <span>HKID/Passport Number</span>
          <el-form-item prop="id_type">
            <v-radio-group
              v-model="formData.id_type"
              :list="personalIdTypOptions"
              class="mgb-5" />
          </el-form-item>
          <el-form-item prop="id_no">
            <v-input
              v-model="formData.id_no"
              class="mg-t-5" />
          </el-form-item>

        </div> -->
        <!--        <div class="form-block">-->
        <!--          <span>Identification</span>-->
        <!--          <v-radio-group-->
        <!--            v-model="formData.id_type"-->
        <!--            :list="personalIdTypOptions"-->
        <!--            class="mg-b-10" />-->
        <!--          <v-input-->
        <!--            v-model="formData.id_no" />-->
        <!--        </div>-->
        <div class="form-block">
          <span>HKID</span>
          <v-input
            v-model="formData.id_no"
            uppercase
            placeholder="A123456(3), please input A1234563"
            class="mg-t-5" />
        </div>
        <div class="form-block">
          <span>Passport No.</span>
          <v-input
            v-model="formData.pp_no"
            uppercase
            class="mg-t-5" />
        </div>
        <div class="form-block">
          <span>Nationality</span>
          <v-select
            v-model="formData.id_nationality_seq"
            :list="nationalityList"
            class="mg-t-5" />
        </div>
        <div class="form-block">
          <span>HKID/Passport</span>
          <file-container
            :edit="true"
            titleName= "HKID/Passport"
            :fileData="{
              url: formData.id_type_pic_url,
              client_name: formData.client_name
            }"
            :otherData="{
              idKey: 'id_type_pic_path_id',
              nameKey: 'id_type_pic_path',
              urlKey: 'id_type_pic_url',
              client_name:'client_name'
            }"
            @delete="handlerDeleteFile"
            @uploadSuccess="handlerUploadSuccess" />
          <!-- <v-upload
        :otherData="{
          index,
          idKey: 'nm_drvr_id_type_pic_path_id',
          nameKey: 'nm_drvr_id_type_pic_path'
        }"
        @uploadSuccess="handlerUploadSuccess"
      /> -->
        </div>

        <!--        <div class="form-block">-->
        <!--          <span>Occupation and Job Nature</span>-->
        <!--          <el-form-item-->
        <!--            ref="occ_id"-->
        <!--            prop="occ_id">-->
        <!--            <v-select-->
        <!--              v-model="formData.occ_id"-->
        <!--              :list="allOptions.occupation" />-->
        <!--          </el-form-item>-->
        <!--        </div>-->
      </div>
      <div v-else>
        <div class="form-block form-identity">
          <span>Company Name</span>
          <el-form-item
            ref="isrd_com_nm"
            prop="isrd_com_nm">
            <v-input
              v-model="formData.isrd_com_nm"
              uppercase />
          </el-form-item>
        </div>
        <div
          v-if="!edit"
          class="form-block">
          <span>Company Email</span>
          <el-form-item
            ref="email"
            prop="email">
            <v-input v-model="formData.email" />
          </el-form-item>

        </div>
        <template v-else>
          <div
            v-if="!form.attached_account"
            class="form-block">
            <span>Company Email</span>
            <div class="flex flex-sb email-text">
              <span>
                {{formData.email}}
              </span>
              <v-button @click="handleChangeEmail(1)">Edit</v-button>
            </div>
          </div>
          <div
            v-if="form.attached_account"
            class="form-block">
            <span>Company Email</span>
            <div class="flex flex-sb email-text email-icon">
              <span>
                <font-awesome-icon icon="link"></font-awesome-icon>
                <span>
                  {{formData.email}}
                </span>
              </span>
              <v-button @click="handleChangeEmail(2)">Edit</v-button>
            </div>
          </div>
        </template>
        <div class="form-block">
          <span>Company Phone Number</span>
          <el-form-item
            ref="phone_no"
            prop="phone_no">
            <v-input
              v-model="formData.phone_no"
              maxlength="8"
              keyNumber
            />
          </el-form-item>

        </div>
        <!-- <div class="form-block">
          <span>Contact Person First Name</span>
          <el-form-item prop="contact_fst">
            <v-input v-model="formData.contact_fst" />
          </el-form-item>
        </div>
        <div class="form-block">
          <span>Contact Person Last Name</span>
          <el-form-item prop="contact_lst">
            <v-input v-model="formData.contact_lst" />
          </el-form-item>
        </div> -->
        <div class="form-block">
          <span>Contact Person Name</span>
          <el-form-item
            ref="contact_nm"
            prop="contact_nm">
            <v-input v-model="formData.contact_nm" />
          </el-form-item>
        </div>
        <!--        <div class="form-block">-->
        <!--          <span>Contact Person Occupation</span>-->
        <!--          <el-form-item-->
        <!--            ref="contact_occ_id"-->
        <!--            prop="contact_occ_id"-->
        <!--          >-->
        <!--            <v-select-->
        <!--              v-model="formData.contact_occ_id"-->
        <!--              :list="allOptions.occupation"/>-->
        <!--          </el-form-item>-->
        <div class="form-block">
          <span>Contact Person Mobile No.</span>
          <el-form-item
            ref="contact_phone"
            prop="contact_phone">
            <v-input
              v-model="formData.contact_phone"
              maxlength="8"
              keyNumber
            />
          </el-form-item>
        </div>
        <!--        <div class="form-block">-->
        <!--          <span>Contact Person Email</span>-->
        <!--          <el-form-item-->
        <!--            ref="contact_email"-->
        <!--            prop="contact_email">-->
        <!--            <v-input v-model="formData.contact_email" />-->
        <!--          </el-form-item>-->
        <!--        </div>-->
        <div class="form-block">
          <span>Nature of Business</span>
          <el-form-item
            ref="bsns_nature_id"
            prop="bsns_nature_id">
            <v-select
              v-model="formData.bsns_nature_id"
              :list="allOptions.industry" />
          </el-form-item>
        </div>
        <div class="form-block">
          <span> Business Registration Number</span>
          <el-form-item
            ref="id_no"
            prop="id_no">
            <v-input
              v-model="formData.id_no"
              uppercase
              letterAndNumber
              maxlength="8"
            />
          </el-form-item>
        </div>

        <div class="form-block">
          <span>Business Registration Certification</span>
          <el-form-item
            ref="id_type_pic_path_id"
            prop="id_type_pic_path_id">
            <file-container
              :edit="true"
              titleName= "Business Registration Certification"
              :fileData="{
                url: formData.id_type_pic_url,
                client_name: formData.client_name
              }"
              :otherData="{
                idKey: 'id_type_pic_path_id',
                nameKey: 'id_type_pic_path',
                urlKey: 'id_type_pic_url',
                client_name:'client_name'
              }"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess" />
          </el-form-item>
          <!-- <v-upload
          :otherData="{
            index,
            idKey: 'nm_drvr_id_type_pic_path_id',
            nameKey: 'nm_drvr_id_type_pic_path'
          }"
          @uploadSuccess="handlerUploadSuccess"
        /> -->
        </div>
      </div>

    </el-form>

  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {checkEmail, checkPhone,checkMobile} from '@/utils/validate'
export default {
  name: 'AccountForm',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    edit: {
      type: Boolean,
      default: false
    },
    formDataLock: {
      type: Number,
      default: 0
    }
  },
  data() {
    const checkPPNo = (rule, value, callback) => {
      const { id_no } = this.formData
      // 得細分跟 id no
      // if(!value) {
      //   callback(new Error(this.$t('placeholder.input')))
      // }
      // 這裏要校驗格式 todo
      callback()
    }
    const checkIdNo = (rule, value, callback) => {
      const { identity, pp_no } = this.formData
      var reg = /[^\w\/]/
      if (identity == 2 && value && reg.test(value)) {
        callback( new Error( '公司註冊證書編號最多为8位字母和數字' ) )
      }
      else {
        if(!pp_no && !value) {
          callback(new Error(this.$t('placeholder.input')))
        }
      }
      callback()
    }
    return {
      oldFormDataLock: -1,
      formData: {
        identity: 1,
        phone: '',
        phone_no:'',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        email: '',
        isrd_sex: '',
        isrd_dob: '',
        id_type: '',
        isrd_title: '',
        id_no: '',
        pp_no: '',
        // occ_id: '',
        isrd_com_nm: '',
        // contact_lst: '',
        // contact_fst: '',
        contact_nm: '',
        // contact_email: '',
        contact_phone: '',
        // contact_occ_id:'',
        bsns_nature_id: '',

        id_type_pic_path:'',
        id_type_pic_url:'',
        client_name:'',
        id_nationality_seq: ''
        // : '',
      },
      extraRules: {
        id_no: [
          { validator: checkIdNo, trigger: ['change', 'blur'] }
        ],
      },
      // birth:''
    }
  },
  computed:{
    formRule(){
      var rule = JSON.stringify(this.rules)
      const select = [
        'isrd_com_nm',
        'email',
        'phone_no',
        'bsns_nature_id',
        'id_no',
        // 'id_type_pic_path_id'
      ]
      const data =[
        'isrd_lst_nm',
        'isrd_fst_nm',
        'isrd_sex',
        'isrd_dob',
        'id_type',
        'isrd_title',

        'occ_id',
        'contact_lst',
        'contact_fst',
        // 'contact_email',
        'contact_phone',
        'email'

      ]
      rule = JSON.parse(rule)

      data.forEach(item=>{
        rule[item][0].required =false
        if(item === 'contact_phone') {
          rule[item][0].required =true
          rule[item][1].validator = checkMobile
        }
        if(item ==='email') {
          rule[item][0].required =true
          rule[item][1].validator = checkEmail
        }
      })
      const checkRequired = (rule, value, callback) => {
        const valueResult = value !== null && value !== ''
        const { field } = rule
        if(select.includes(field) && !valueResult) {
          callback(new Error(this.$t('placeholder.input')))
        }
        callback()
      }
      const checkIdNo = (rule, value, callback) => {
        const { identity, pp_no } = this.formData
        var reg = /[^\w\/]/
        if ( value && reg.test(value)) {
          callback( new Error( '公司註冊證書編號最多为8位字母和數字' ) )
        }
        else {
          if(!pp_no && !value) {
            callback(new Error(this.$t('placeholder.input')))
          }
        }
        callback()
      }
      select.forEach(item=>{
        if(this.formData.identity == 2)
        {
          rule[item][0].validator = checkRequired
          if(item=='id_no')
            rule[item][0].validator = checkIdNo
        }
      })
      return rule
    },
    nationalityList(){
      return this.globalOptions.id_nationality_seq || []
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        // this.birth = val.isrd_dob
        if(this.formDataLock !== this.oldFormDataLock) {
          // 觸發更新就賦值，避免二次更新
          this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {

            if(key in val) {
              this.formData[key] = val[key]
            }
          })
          let {id_type_pic} =val
          // idKey: 'id_type_pic_path_id',
          //     nameKey: 'id_type_pic_path',
          //     urlKey: 'id_type_pic_url',
          //     client_name:'client_name'

          if(id_type_pic)
          {
            let {client_name,id,path,url} =id_type_pic
            this.$set(this.formData, 'id_type_pic_path_id', id)
            this.$set(this.formData, 'id_type_pic_path', path)
            this.$set(this.formData, 'id_type_pic_url', url)
            this.$set(this.formData, 'client_name', client_name)
          }else{
            this.$set(this.formData, 'id_type_pic_path_id', '')
            this.$set(this.formData, 'id_type_pic_path', '')
            this.$set(this.formData, 'id_type_pic_url', '')
            this.$set(this.formData, 'client_name', '')
          }
        }
      }
    },
    'formData.identity': {
      handler(val) {
        // if(val === 2) {
        //   this.formData.id_type = 3
        // } else {
        //   this.formData.id_type = ''
        // }
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      }
    },
    'formData.contact_nm':{
      immediate:true,
      handler(val) {
        if(val)
          this.formData.contact_nm = this.formData.contact_nm.toLocaleUpperCase()
      }
    }
  },
  methods: {
    // getBirthDay(val){
    //   this.formData.isrd_dob = val
    // },
    handleChangeEmail(type=1){
      let {isrd_com_nm,email} = this.formData||{}
      this.$emit('changeEmail',{isrd_com_nm,email,type})
    },
    handlerChange(){
      this.$emit('handlerChange',this.formData.identity)
    },
    // file-container 組件刪除文件
    handlerDeleteFile(otherData) {
      const { type, index, idKey, nameKey, urlKey } = otherData
      this.$set(this.formData, idKey, '')
      this.$set(this.formData, urlKey, '')
      this.$set(this.formData, nameKey, '')
      this.$set(this.formData, 'client_name', '')
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { type, idKey, nameKey,  urlKey, target } = otherData
      const { id, name, url,client_name } = data

      this.$set(this.formData, idKey, id)
      this.$set(this.formData, urlKey, url)
      this.$set(this.formData, nameKey, name)
      this.$set(this.formData, 'client_name', client_name)
      this.$refs['form'].clearValidate([idKey])
    },
    submitForm(formName) {
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          //
          let params = JSON.parse(JSON.stringify(this.formData))
          if(this.formData.identity === 2) {
            params.id_type = 3
            if(!params.id_no) {
              params.id_no = ''
              params.id_type = ''
            }
          }
          // 改需求啦啦啦
          // else {
          //   const { pp_no, id_no } = params
          //   if(pp_no && !id_no) {
          //     params.id_type = 2
          //     params.id_no = pp_no
          //   }
          //   else {
          //     params.id_type = 1
          //   }
          // }
          else {
            // if(params.id_type == 1) {
            //   if(!params.id_no) {
            //     params.id_type = ''
            //   }
            // }
            // else {
            //   if(!params.id_no) {
            //     params.id_type = ''
            //   }
            //   else {
            //     params.pp_no = params.id_no
            //     params.id_no = ''
            //   }
            // }
          }
          this.$emit('getFormData', formName, params)
        }
        else {
          console.log(rules)
          this.scrollToValidDom(rules)
        }
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.account-form {
  .mgb-5 {
    margin-bottom: 5px;
  }
  .form-block {
    margin-bottom: 15px;
    & > span:first-child {
      display: block;
      padding-bottom: 5px;
      color: #616266;
      font-weight: bold;
      font-size: 14px;
    }
  }
  .email-text{
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
    &.email-icon{
      color: #6F42C1!important;
      span{
        margin-left: 6px;
      }
    }
    .el-button{
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-sizing: border-box;
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      border-radius: 6px;

      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.15px;
      color: #24292E;
    }
  }
}
</style>
